import { Box, Typography, Container } from "@mui/material";

const WorkplaceCulture = () => {
  return (
    <Box
      sx={{
        py: { xs: 10, md: 16 },
        backgroundImage:
          "url('https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        color: "#fff",
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.45) 60%, rgba(0,0,0,0.5) 100%)",
          zIndex: 1,
        }}
      />

   
      <Box
        sx={{
          position: "absolute",
          bottom: -80,
          left: -80,
          width: 250,
          height: 250,
          borderRadius: "50%",
          background: "rgba(26,35,126,0.15)",
          filter: "blur(100px)",
          zIndex: 0,
        }}
      />

      <Container
        maxWidth="md"
        sx={{
          position: "relative",
          zIndex: 2,
          textAlign: "center",
          backdropFilter: "blur(6px)",
          background: "rgba(255,255,255,0.05)",
          borderRadius: 3,
          p: { xs: 4, md: 6 },
        }}
      >
        <Typography
          variant="h4"
          fontWeight={800}
          mb={3}
          sx={{
            fontSize: { xs: "1.8rem", md: "2.8rem" },
            letterSpacing: "1px",
          }}
        >
          Our Workplace Culture
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: "1rem", md: "1.25rem" },
            color: "#f0f0f0",
            lineHeight: 1.6,
          }}
        >
          A motivated and skilled workforce is our greatest asset. We foster
          innovation, collaboration, and personal growth in an inclusive
          environment that celebrates diversity and excellence.
        </Typography>
      </Container>
    </Box>
  );
};

export default WorkplaceCulture;
